// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Button, color } from '@kintent/glide';

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.components.button.background.primary};

  margin: 0px;
  overflow-wrap: break-word;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.01em;
  -webkit-box-align: center;
  align-items: center;
  color: #032d5e;
  display: inline-grid;
  gap: 8px;
  grid-auto-flow: column;
  -webkit-box-pack: center;
  justify-content: center;

  // This is ServiceNow specific
  &:hover {
    background-color: #62d84e;
  }

  // Handle the secondary variant in a single place instead of doing one offs
  &.secondary {
    color: black;

    border: 1px solid ${({ theme }) => color(theme.colorV2.system.border, 50)};
    background-color: white;
  }

  & > span {
    font-weight: 500;
  }
`;
